<template>
  <div class="settings">
    <PageMenu :linksList="linksComputedList" />
    <router-view />
  </div>
</template>

<script>
/* eslint-disable */
import {mapGetters} from 'vuex';
import PageMenu from '@/components/global/pageMenu';

export default {
  name: 'SettingsIndex',
  components: { PageMenu },
  computed: {
    ...mapGetters([
      'get_user_permission',
    ]),
    linksComputedList() {
      return [
        {
          name: 'Printers',
          link: '/settings/platform/printers',
          visible: this.get_user_permission('settings/printer').view,
        },
        {
          name: 'team',
          link: '/settings/platform/team',
          visible: this.get_user_permission('settings/team').view,
        },
        {
          name: 'SMTP',
          link: '/settings/platform/smtp',
          visible: this.get_user_permission('settings/smtp').view,
        },
        {
          name: 'system',
          link: '/settings/platform/system',
          visible: this.get_user_permission('settings/system').view,
        },
      ]
    },
  },
};
</script>
